import { ReactComponent as BurgerIcon } from '@Icons/additional/burger.svg';
import '../header-actions.css';

interface UserProfileProps {}

const UserProfileMobile: React.FC<UserProfileProps> = () => {
  return (
    <div className="header-action-component user-profile-mobile trojan-neumorphism-box trojan-neumorphism-box-shadow">
      <BurgerIcon />
    </div>
  );
};

export default UserProfileMobile;
